import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { Subscription } from "rxjs";
import { BaseComponent } from 'sharedFeatures/base';
import { DocumentListener } from "sharedFeatures/sharedModels/documentListener";
import { DragDropManagerService } from 'sharedFeatures/sharedServices/drag-drop-manager.service';
import { LayoutUtil, Utils } from 'sharedFeatures/utils';
import { BrowserDetectEventUtil } from 'sharedFeatures/utils/browser-detect-util';
import { BrowserDetectUtil } from 'sharedGuiSmall/utils/browser-detect-util';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { LayoutSmallUtil } from 'sharedGuiSmall/utils/layout-util';

@Component({
  selector: 'scrolldiv',
  templateUrl: './scrolldiv.component.html',
    styleUrls: ['./scrolldiv.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ScrollComponent extends BaseComponent {

    @ViewChild('scrollBody')
    scrollBody!: ElementRef;

	scrollerHDiv!: HTMLDivElement;
    scrollerVDiv!: HTMLDivElement;

	@Input()
    public scrollerSize: number = 10;

    @Input()
    verticalBorderLeftStyle: string = '';

	@Input()
    navigatorSize: number = 10;
    scrollerLastLeft: number = -1;
    scrollerLastTop: number = -1;
    scrollHorizontalIndent: number = 1;

    @Input()
    scrollVerticalIndent: number = 1;

    horizontalScrollerTop: number = 0;
    verticalScrollerLeft: number = 0;
    alwaysVisibleScroll: boolean = true;

    @Input()
    verticalScrollPosition: string = 'right';

    scrollTopValue: number = 0;
    scrollLeftValue: number = 0;

	@Input()
    cls: string = '';

    @Output()
    private onScrollDown = new EventEmitter<number>();

    @Output()
    private layoutChange = new EventEmitter<any>();

    //private
    thumbPos: number = 0;

    mouseWheelScrollMove: number = 25;


    //clickScrollMove: number = 20;


    //for inner use
    documentListeners: Array<DocumentListener> = [];

	navigatorIsDown: boolean = false;
	emptyAreaIsDown: boolean = false;

	currentComponentRect: DOMRect | undefined;
	currentScrollBodyRect: DOMRect | undefined;


    private isAutoScrollDetect: boolean = true;

    private dragInterval!: NodeJS.Timeout;
    private drgEndSubscription: Subscription;

    private moveListener: Function | undefined;

    private touchStartX: number = 0;
    private touchStartY: number = 0;

    private verticalScrollAllowed: boolean = true;

    @Input()
    public horizontalScrollAllowed: boolean = true;

    private isOverMe: boolean = false;

  constructor(renderer: Renderer2,
              el: ElementRef,
              private ddService: DragDropManagerService) {

      super(el, renderer);
      this.drgEndSubscription = this.ddService.getDragEnd().subscribe(this.onDragEnd.bind(this));

  }

  //private
  isRelativeContainer(): boolean {

      let el = this.getElDom();

      let addDiv = this.r.createElement('div');
      this.r.appendChild(el, addDiv)
      this.r.setStyle(addDiv, 'top', 1 + 'px')
      this.r.setStyle(addDiv, 'left', 1 + 'px')

      let box = addDiv.getBoundingClientRect();
      let parentBox = el.getBoundingClientRect();

      let divLeft = DomSmallUtils.position(addDiv).left;
      let divTop = DomSmallUtils.position(addDiv).top;

      this.r.removeChild(el, addDiv)

      if ((parentBox.left + divLeft == box.left) && (parentBox.top + divTop == box.top)) return true;

	  return false;

  }

    getContentEl(): HTMLElement {
        let me = this;
        return me.scrollBody.nativeElement;
    }

  private isFirefox(): boolean {

	  let match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);

	  return match? true: false;

  }

  ngAfterViewInit(): void {


	  this.onLayoutChange();

      this.currentComponentRect = this.getElDom().getBoundingClientRect();
	  this.currentScrollBodyRect = this.scrollBody.nativeElement.getBoundingClientRect();

  }

    public detectScroll(): void {

        let newComponentRect = this.getElDom().getBoundingClientRect();
        let newScrollBodyRect = this.scrollBody.nativeElement.getBoundingClientRect();

        if (!LayoutUtil.isRectsSame(this.currentComponentRect, newComponentRect) || !LayoutSmallUtil.isRectsSizeSame(this.currentScrollBodyRect, newScrollBodyRect)) this.onLayoutChange();


        this.currentComponentRect = newComponentRect;
        this.currentScrollBodyRect = newScrollBodyRect;

        const parentEl = this.getElDom()?.parentElement;

        if (parentEl?.tagName?.toLowerCase() === 'form' && this.currentScrollBodyRect?.height !== 0 && this.currentComponentRect?.height === 0) {
            console.warn('css fix dosent work - changing currentComponentRect height programmatically');
            const parentRect = parentEl.getBoundingClientRect();
            const calclucatedCompRectHeight = parentRect.bottom - this.currentComponentRect.top;
            this.r.setStyle(this.getElDom(), 'height', `${calclucatedCompRectHeight}px`);
        }
    }

  ngAfterViewChecked(): void {

      if (!this.isAutoScrollDetect) return;

      this.detectScroll();


  }

  setAutoScrollDetect(autoDetect: boolean): void {

      this.isAutoScrollDetect = autoDetect;

  }

  onLayoutChange(): void {

      let me = this;
      let isFirst;
      if ((this.horizontalScrollAllowed && !me.scrollerHDiv) || (this.verticalScrollAllowed && !me.scrollerVDiv)) isFirst = true;
      else isFirst = false;

      let isRelative = me.isRelativeContainer();

      let el = this.getElDom();
      let placeScrollerEl = this.getElDom();

      if (!placeScrollerEl) return;

      if (isFirst) {

          if (this.horizontalScrollAllowed) {

              me.scrollerHDiv = me.createScrollerHDiv();
              this.r.appendChild(placeScrollerEl, me.scrollerHDiv);

          }

          if (this.verticalScrollAllowed) {

              me.scrollerVDiv = me.createScrollerVDiv();
              this.r.appendChild(placeScrollerEl, me.scrollerVDiv);

          }

      }

      if (BrowserDetectUtil.isMac()) {

          if (this.horizontalScrollAllowed) this.r.setStyle(el, 'overflowX', 'auto');
          if (this.verticalScrollAllowed) this.r.setStyle(el, 'overflowY', 'auto');

      }
      else {

          this.r.setStyle(el, 'overflow', 'hidden');
          this.r.setStyle(el, 'overflowX', 'hidden');
          this.r.setStyle(el, 'overflowY', 'hidden');

      }

      DomSmallUtils.removeStyle(this.r, me.getContentEl(), 'width');

      let w = this.getCeilOuterWidth(el);
      let h = this.getCeilOuterHeight(el);

      let pos = DomSmallUtils.position(el);
      let placePos = DomSmallUtils.position(placeScrollerEl);

      const isVerticalScroll = me.isVerticalScroll();
      const isHorizontalScroll = me.isHorizontalScroll() && this.horizontalScrollAllowed;

      if (this.horizontalScrollAllowed) {

          let divWidth = w - 2 * me.scrollHorizontalIndent;
          let cutCornerHorizontal = isVerticalScroll ? me.scrollerSize : 0;

          if (!me.horizontalScrollerTop)
              me.horizontalScrollerTop = isRelative ? (h - me.scrollerSize) : (pos.top + h - me.scrollerSize);

          let leftPos = isRelative ? (pos.left - placePos.left + me.scrollHorizontalIndent) : (pos.left + me.scrollHorizontalIndent);
          me.scrollerHDiv.setAttribute("style", "width:" + (divWidth - cutCornerHorizontal) + "px;top:" + me.horizontalScrollerTop + "px;left:" + leftPos + "px;display:;height:" + me.scrollerSize + "px");
          this.r.setStyle(me.scrollerHDiv, 'zIndex', Utils.getZIndex(this.scrollBody.nativeElement));
          DomSmallUtils.setStyle(this.r, DomSmallUtils.find(me.scrollerHDiv, 'div.thumb-area'), 'width', divWidth - cutCornerHorizontal - 2 * me.navigatorSize + 'px');
          DomSmallUtils.setStyle(this.r, DomSmallUtils.find(me.scrollerHDiv, 'div.thumb-area'), 'left', me.navigatorSize + 'px');

          if (me.alwaysVisibleScroll) this.r.setStyle(this.scrollerHDiv, 'opacity', 1);

      }

      if (this.verticalScrollAllowed) {

          //stick vertical scroller div to this panel
          let divHeight = h - 2 * me.scrollVerticalIndent;
          if (!me.verticalScrollerLeft && me.verticalScrollerLeft != 0)
              me.verticalScrollerLeft = isRelative ? (w - me.scrollerSize) : (pos.left + w - me.scrollerSize);
          if (isVerticalScroll) {

              DomSmallUtils.removeStyle(this.r, me.getContentEl(), 'width');

              let contentW = this.getCeilOuterWidth(me.getContentEl());
              DomSmallUtils.setStyle(this.r, me.getContentEl(), 'width', ((contentW >= w - me.scrollerSize) ? (w - me.scrollerSize) : contentW) + 'px');

          }



          if (me.verticalScrollPosition) {

              if (me.verticalScrollPosition == 'right' || !isVerticalScroll) {
                  me.verticalScrollerLeft = isRelative ? (w - me.scrollerSize) : (pos.left + w - me.scrollerSize);
                  if (me.getContentEl()) DomSmallUtils.setStyle(this.r, me.getContentEl(), 'margin-left', '0px');
              }
              else {
                  me.verticalScrollerLeft = isRelative ? 0 : pos.left;
                  DomSmallUtils.setStyle(this.r, me.getContentEl(), 'margin-left', me.scrollerSize + 'px');
              }

          }



          let topPos = isRelative ? (pos.top - placePos.top + me.scrollVerticalIndent) : (pos.top + me.scrollVerticalIndent);

          let borderLeftStyle = this.verticalBorderLeftStyle ? ('border-left: ' + this.verticalBorderLeftStyle + ' #e1e8ee;') : '';

          let cutCornerVertical = isHorizontalScroll ? me.scrollerSize : 0;

          me.scrollerVDiv.setAttribute("style", "height:" + (divHeight - cutCornerVertical) + "px;left:" + me.verticalScrollerLeft + "px;top:" + topPos + "px;display:;width:" + me.scrollerSize + "px;" + borderLeftStyle);
          this.r.setStyle(me.scrollerVDiv, 'zIndex', Utils.getZIndex(this.scrollBody.nativeElement));
          DomSmallUtils.setStyle(this.r, DomSmallUtils.find(me.scrollerVDiv, 'div.thumb-area'), 'height', divHeight - cutCornerVertical - 2 * me.navigatorSize + 'px');
          DomSmallUtils.setStyle(this.r, DomSmallUtils.find(me.scrollerVDiv, 'div.thumb-area'), 'top', me.navigatorSize + 'px');

          if (me.alwaysVisibleScroll) this.r.setStyle(this.scrollerVDiv, 'opacity', 1);

      }



      //add mouse listeners to scroller
      if (isFirst) {
          if (this.horizontalScrollAllowed) me.addHorizontalScrollerListeners();
          if (this.verticalScrollAllowed) me.addVerticalScrollerListeners();
      }

      if (this.horizontalScrollAllowed) me.updateScroller(true);

      if (this.verticalScrollAllowed) me.updateVerticalScroller(true);


      if (this.horizontalScrollAllowed) me.updateTopPosition();
      if (this.verticalScrollAllowed) me.updateLeftPosition();

      if (this.layoutChange) this.layoutChange.emit();

	}

    //private
    createScrollerHDiv(): HTMLDivElement {

        let me = this;
        let div = document.createElement('div');
		let cls = me.cls ? ("scrollbarX " + me.cls) : "scrollbarX";
        div.setAttribute("class", cls);
        let startNavigator = document.createElement('div');
        startNavigator.setAttribute("class", "horizontal-navigator-start");

		this.r.setStyle(startNavigator, 'width', me.navigatorSize + 'px');
		this.r.setStyle(startNavigator, 'height', me.scrollerSize + 'px');

        div.appendChild(startNavigator);

        let thumbAreaDiv = document.createElement('div');
        thumbAreaDiv.setAttribute("class", "thumb-area");

        this.r.setStyle(thumbAreaDiv, 'height', me.scrollerSize + 'px');
        this.r.setStyle(thumbAreaDiv, 'cursor', 'default');

        div.appendChild(thumbAreaDiv);

        let thumbDiv = document.createElement('div');
        thumbDiv.setAttribute("class", "thumb");
        thumbAreaDiv.appendChild(thumbDiv);
        let endNavigator = document.createElement('div');
        endNavigator.setAttribute("class", "horizontal-navigator-end");

        this.r.setStyle(endNavigator, 'width', me.navigatorSize + 'px');
        this.r.setStyle(endNavigator, 'height', me.scrollerSize + 'px');

        this.r.setStyle(thumbDiv, 'top', (me.scrollerSize - me.navigatorSize) / 2 + 'px');

        div.appendChild(endNavigator);

        return div;

    }

    addHorizontalScrollerListeners(): void {

        let me = this;

        let el = this.getElDom();


        function scrollPaneHandler() {

            me.updateScroller(false);

        }

        el.addEventListener('scroll', scrollPaneHandler);

        let scrollerAreaEl = <HTMLElement>this.scrollerHDiv.querySelector(`:scope div.thumb-area`);

        scrollerAreaEl.addEventListener('mouseup', function (e: MouseEvent) {
            e.preventDefault();
        });

        scrollerAreaEl.addEventListener('mousedown', function (e: MouseEvent) {
            e.preventDefault();

            if(document.querySelector('iframe')) me.r.addClass(document.querySelector('iframe'), 'nopointer');

            me.r.addClass(document.body, 'unselectable');
            let last = e.pageX;
            me.r.addClass(scrollerAreaEl, 'dragScrolling');

            function mouseMove(e: MouseEvent) {

                e.preventDefault();
                if (!last || me.emptyAreaIsDown) return; // Don`t move scroll when mouse is on emptyArea
                let elSize = DomSmallUtils.width(scrollerAreaEl);
                let scrollSize = el.scrollWidth;
                let ratio = elSize / scrollSize;
                let move = (e.pageX - last) / ratio;


                if (me.scrollLeftValue == null || me.scrollLeftValue == undefined)
                    me.scrollLeftValue = el.scrollLeft;
                me.scrollLeftValue += move;

                const maxScrollLeft = scrollSize - el.clientWidth;
                if (me.scrollLeftValue > maxScrollLeft) me.scrollLeftValue = maxScrollLeft;
                if (me.scrollLeftValue < 0) me.scrollLeftValue = 0;

                el.scrollLeft = me.scrollLeftValue;
                last = e.pageX;

                return false;

            }


            document.addEventListener('mousemove', mouseMove);
            me.documentListeners.push({ key: 'mousemove', func: mouseMove });

            function selectStart(e: Event) {
                e.preventDefault();

                return false;
            }

            el.addEventListener('selectstart', selectStart);

            function mouseUp(e: MouseEvent) {
                document.removeEventListener('mousemove', mouseMove);
                el.removeEventListener('selectstart', selectStart);
                me.r.removeClass(document.body, 'unselectable');

                me.r.removeClass(scrollerAreaEl, 'dragScrolling');
                document.removeEventListener('mouseup', mouseUp);

                if(document.querySelector('iframe')) me.r.removeClass(document.querySelector('iframe'), 'nopointer');

                me.emptyAreaIsDown = false;
            }

            document.addEventListener('mouseup', mouseUp);
            me.documentListeners.push({ key: 'mouseup', func: mouseUp });
        });

        // For mobile devices
        scrollerAreaEl.addEventListener('touchstart', (e: TouchEvent) => {
            if (e.targetTouches.length !== 1) return;

            if(document.querySelector('iframe')) me.r.addClass(document.querySelector('iframe'), 'nopointer');

            const touch = e.targetTouches[0];
            let last = touch.pageX;

            me.r.addClass(document.body, 'unselectable');
            me.r.addClass(scrollerAreaEl, 'dragScrolling');

            function touchMove(e: TouchEvent) {
                if (e.targetTouches.length !== 1) return;
                e.preventDefault();
                if (!last) return;

                const touch = e.targetTouches[0];
                let elSize = DomSmallUtils.width(scrollerAreaEl);
                let scrollSize = el.scrollWidth;
                let ratio = elSize / scrollSize;
                let move = (touch.pageX - last) / ratio;

                if (move > 0 && me.onScrollDown)
                    me.onScrollDown.emit(me.mouseWheelScrollMove);

                if (me.scrollLeftValue == null || me.scrollLeftValue == undefined)
                    me.scrollLeftValue = el.scrollLeft;
                me.scrollLeftValue += move;

                const maxScrollLeft = scrollSize - el.clientWidth;
                if (me.scrollLeftValue > maxScrollLeft) me.scrollLeftValue = maxScrollLeft;
                if (me.scrollLeftValue < 0) me.scrollLeftValue = 0;

                el.scrollLeft = me.scrollLeftValue;
                last = touch.pageX;

                return false;
            }

            scrollerAreaEl.addEventListener('touchmove', touchMove);

            function touchEnd(e: TouchEvent) {
                scrollerAreaEl.removeEventListener('touchmove', touchMove);
                scrollerAreaEl.removeEventListener('touchend', touchEnd);

                me.r.removeClass(document.body, 'unselectable');
                me.r.removeClass(scrollerAreaEl, 'dragScrolling');
                if(document.querySelector('iframe')) me.r.removeClass(document.querySelector('iframe'), 'nopointer');
            }

            scrollerAreaEl.addEventListener('touchend', touchEnd);
        });

        let navigatorStart = <HTMLElement>this.scrollerHDiv.querySelector(`:scope .horizontal-navigator-start`);
        let navigatorEnd = <HTMLElement>this.scrollerHDiv.querySelector(`:scope .horizontal-navigator-end`);

        function moveForward(jumpLen: number) {

            if (me.thumbPos != 0 && !me.thumbPos) return;
            let elSize = DomSmallUtils.width(scrollerAreaEl);
            let scrollSize = el.scrollWidth;
            let ratio = elSize / scrollSize;
            let jmpLn = (jumpLen ? jumpLen : 2);
            let move = jmpLn / ratio;

            el.scrollLeft = (el.scrollLeft + move);
            me.thumbPos = me.thumbPos + jmpLn;
            me.updateScroller(false);

        }

        function moveBackward(jumpLen: number) {

            if (me.thumbPos != 0 && !me.thumbPos) return;
            let elSize = DomSmallUtils.width(scrollerAreaEl);
            let scrollSize = el.scrollWidth;
            let ratio = elSize / scrollSize;
            let jmpLn = (jumpLen ? jumpLen : 2);
            let move = jmpLn / ratio;

            el.scrollLeft = (el.scrollLeft - move);
            me.thumbPos = me.thumbPos - jmpLn;
            me.updateScroller(false);

        }

        function navigatorClick(e: MouseEvent) {
            if (e.target == navigatorStart) moveBackward(2);
            if (e.target == navigatorEnd) moveForward(2);
        }

        function navigatorDown(e: MouseEvent) {

            me.r.removeClass(document.body, 'unselectable');
            me.navigatorIsDown = true;

            function onEverlastingScroll() {

                if (me.navigatorIsDown) {

                    navigatorClick(e);
                    setTimeout(onEverlastingScroll, 50);

                }

            }

            setTimeout(function () {
                if (me.navigatorIsDown) onEverlastingScroll();
            }, 300);


        }

        function navigatorUp() {

            me.r.removeClass(document.body, 'unselectable');
            me.navigatorIsDown = false;

        }

        navigatorStart.addEventListener('click', navigatorClick);
        navigatorStart.addEventListener('mousedown', navigatorDown);
        navigatorStart.addEventListener('mouseup', navigatorUp);
        navigatorStart.addEventListener('mouseout', navigatorUp);
        navigatorEnd.addEventListener('click', navigatorClick);
        navigatorEnd.addEventListener('mousedown', navigatorDown);
        navigatorEnd.addEventListener('mouseup', navigatorUp);
        navigatorEnd.addEventListener('mouseout', navigatorUp);

        function emptyAreaClick(e: MouseEvent, pos: number) {
            let thumbEl = DomSmallUtils.find(me.scrollerHDiv, 'div.thumb');

            if (!pos || (me.thumbPos + DomSmallUtils.width(thumbEl) < pos)) moveForward(DomSmallUtils.width(thumbEl));
            else if (!pos || me.thumbPos > pos) moveBackward(DomSmallUtils.width(thumbEl));
        }


        function emptyAreaDown(e: MouseEvent) {

            me.r.addClass(document.body, 'unselectable');
            me.emptyAreaIsDown = true;

            function onEverlastingScroll() {

                if (me.emptyAreaIsDown) {

                    let oldThumbPos = me.thumbPos;

                    let pointerLeft = e.pageX - DomSmallUtils.offset(<HTMLElement>e.target).left;
                    emptyAreaClick(e, pointerLeft);
                    setTimeout(onEverlastingScroll, 500);

                }
            }

            setTimeout(function () {
                if (me.emptyAreaIsDown) onEverlastingScroll();
            }, 300);


        }

        function emptyAreaUp() {

            me.r.removeClass(document.body, 'unselectable');
            me.emptyAreaIsDown = false;

        }

        scrollerAreaEl.addEventListener('click', function (e: MouseEvent) {
            let el = <HTMLElement>e.target;
            if (!DomSmallUtils.hasClass(el, 'thumb')) {
                let pointerLeft = e.pageX - DomSmallUtils.offset(<HTMLElement>e.target).left;
                emptyAreaClick(e, pointerLeft);
            }
        });

        scrollerAreaEl.addEventListener('mousedown', function (e: MouseEvent) {
            let el = <HTMLElement>e.target;
            if (!DomSmallUtils.hasClass(el, 'thumb')) emptyAreaDown(e);
        });

        scrollerAreaEl.addEventListener('mouseup', function (e: MouseEvent) {
            emptyAreaUp();
        });




        // For mobile devices
        el.addEventListener('touchstart', (e: TouchEvent) => {
            if (e.targetTouches.length === 1) {
                let touch = e.targetTouches[0];
                this.touchStartX = touch.pageX;
            }
        }, false);
        el.addEventListener('touchmove', (e: TouchEvent) => {
            if (e.targetTouches.length === 1) {
                let touch = e.targetTouches[0];

                if (touch.pageX > this.touchStartX) {
                    moveForward(me.mouseWheelScrollMove);
                } else if (touch.pageX < this.touchStartX) {
                    moveBackward(me.mouseWheelScrollMove);
                }
            }
        }, false);


    }

    //private
    createScrollerVDiv(): HTMLDivElement {

        let me = this;
        let div = document.createElement('div');
		let cls = me.cls ? ("scrollbarY " + me.cls) : "scrollbarY";
        div.setAttribute("class", cls);

        if (this.verticalBorderLeftStyle) {
            this.r.setStyle(div, 'border-left', this.verticalBorderLeftStyle + ' #e1e8ee');
        }

        let borderLeftWidth = getComputedStyle(div).borderLeftWidth ? parseInt(getComputedStyle(div).borderLeftWidth) : 0;
        let scrollerSize = me.scrollerSize - borderLeftWidth;


        let startNavigator = document.createElement('div');
        startNavigator.setAttribute("class", "vertical-navigator-start");


		this.r.setStyle(startNavigator, 'width', scrollerSize + 'px');
		this.r.setStyle(startNavigator, 'height', me.navigatorSize + 'px');

        div.appendChild(startNavigator);
        let thumbAreaDiv = document.createElement('div');
        thumbAreaDiv.setAttribute("class", "thumb-area");


		this.r.setStyle(thumbAreaDiv, 'width', scrollerSize + 'px');
		this.r.setStyle(thumbAreaDiv, 'top', me.navigatorSize + 'px');
        this.r.setStyle(thumbAreaDiv, 'cursor', 'default');

        div.appendChild(thumbAreaDiv);


        let thumbDiv = document.createElement('div');
        thumbDiv.setAttribute("class", "thumb");
        thumbAreaDiv.appendChild(thumbDiv);

        let endNavigator = document.createElement('div');
        endNavigator.setAttribute("class", "vertical-navigator-end");


		this.r.setStyle(endNavigator, 'width', scrollerSize + 'px');
		this.r.setStyle(endNavigator, 'height', me.navigatorSize + 'px');

        div.appendChild(endNavigator);

        this.r.setStyle(div, 'width', me.scrollerSize + 'px');

        return div;

    }

    addVerticalScrollerListeners(): void {

        let me = this;

        let el = this.getElDom();


        function scrollPaneHandler() {

            me.updateVerticalScroller(false);

        }



        el.addEventListener('scroll', scrollPaneHandler);

        let scrollerAreaEl = <HTMLElement>this.scrollerVDiv.querySelector(`:scope div.thumb-area`);

        scrollerAreaEl.addEventListener('mouseup', function (e: MouseEvent) {
            e.preventDefault();
        })

        scrollerAreaEl.addEventListener('mousedown', function (e: MouseEvent) {
            e.preventDefault();
            if(document.querySelector('iframe')) me.r.addClass(document.querySelector('iframe'), 'nopointer');
            me.r.addClass(document.body, 'unselectable');
            let last = e.pageY;
            me.r.addClass(scrollerAreaEl, 'dragScrolling');

            function mouseMove(e: MouseEvent) {

                e.preventDefault();
                if (!last || me.emptyAreaIsDown) return; // Don`t move scroll when mouse is on emptyArea
                let elSize = DomSmallUtils.height(scrollerAreaEl);
                let scrollSize = el.scrollHeight;
                let ratio = elSize / scrollSize;


                let move = (e.pageY - last) / ratio;


                if (move > 0 && me.onScrollDown)
                    me.onScrollDown.emit(me.mouseWheelScrollMove);

                if (me.scrollTopValue == null || me.scrollTopValue == undefined)
                    me.scrollTopValue = el.scrollTop;
                me.scrollTopValue += move;

                const maxScrollTop = scrollSize - el.clientHeight;
                if (me.scrollTopValue > maxScrollTop) me.scrollTopValue = maxScrollTop;
                if (me.scrollTopValue < 0) me.scrollTopValue = 0;

                el.scrollTop = me.scrollTopValue;
                last = e.pageY;
                //me.updateVerticalScroller(false);

                return false;

            }


            document.addEventListener('mousemove', mouseMove);
            me.documentListeners.push({ key: 'mousemove', func: mouseMove });

            function selectStart(e: Event) {
                e.preventDefault();

                return false;
            }

            el.addEventListener('selectstart', selectStart);

            function mouseUp(e: MouseEvent) {
                document.removeEventListener('mousemove', mouseMove);
                el.removeEventListener('selectstart', selectStart);
                me.r.removeClass(document.body, 'unselectable');

                me.r.removeClass(scrollerAreaEl, 'dragScrolling');
                document.removeEventListener('mouseup', mouseUp);
                if(document.querySelector('iframe')) me.r.removeClass(document.querySelector('iframe'), 'nopointer');

                me.emptyAreaIsDown = false;
            }

            document.addEventListener('mouseup', mouseUp);
            me.documentListeners.push({ key: 'mouseup', func: mouseUp });




        });

        // For mobile devices
        scrollerAreaEl.addEventListener('touchstart', (e: TouchEvent) => {
            if (e.targetTouches.length !== 1) return;

            if(document.querySelector('iframe')) me.r.addClass(document.querySelector('iframe'), 'nopointer');

            const touch = e.targetTouches[0];
            let last = touch.pageY;

            me.r.addClass(document.body, 'unselectable');
            me.r.addClass(scrollerAreaEl, 'dragScrolling');

            function touchMove(e: TouchEvent) {
                if (e.targetTouches.length !== 1) return;
                e.preventDefault();
                if (!last) return;

                const touch = e.targetTouches[0];
                let elSize = DomSmallUtils.height(scrollerAreaEl);
                let scrollSize = el.scrollHeight;
                let ratio = elSize / scrollSize;
                let move = (touch.pageY - last) / ratio;

                if (move > 0 && me.onScrollDown)
                    me.onScrollDown.emit(me.mouseWheelScrollMove);

                if (me.scrollTopValue == null || me.scrollTopValue == undefined)
                    me.scrollTopValue = el.scrollTop;
                me.scrollTopValue += move;

                const maxScrollTop = scrollSize - el.clientHeight;
                if (me.scrollTopValue > maxScrollTop) me.scrollTopValue = maxScrollTop;
                if (me.scrollTopValue < 0) me.scrollTopValue = 0;

                el.scrollTop = me.scrollTopValue;
                last = touch.pageY;
                me.updateVerticalScroller(false);

                return false;
            }

            scrollerAreaEl.addEventListener('touchmove', touchMove);

            function touchEnd(e: TouchEvent) {
                scrollerAreaEl.removeEventListener('touchmove', touchMove);
                scrollerAreaEl.removeEventListener('touchend', touchEnd);

                me.r.removeClass(document.body, 'unselectable');
                me.r.removeClass(scrollerAreaEl, 'dragScrolling');
                if(document.querySelector('iframe')) me.r.removeClass(document.querySelector('iframe'), 'nopointer');
            }

            scrollerAreaEl.addEventListener('touchend', touchEnd);
        });

        let navigatorStart = <HTMLElement>this.scrollerVDiv.querySelector(`:scope .vertical-navigator-start`);
        let navigatorEnd = <HTMLElement>this.scrollerVDiv.querySelector(`:scope .vertical-navigator-end`);

        function moveDown(jumpLen: number) {

            if (me.onScrollDown)
                me.onScrollDown.emit(jumpLen);

            if (me.thumbPos != 0 && !me.thumbPos) {
                console.log('moveDown', 'me.thumbPos is null');
                return;
            }
            let elSize = DomSmallUtils.height(scrollerAreaEl);
            let scrollSize = el.scrollHeight;
            let ratio = elSize / scrollSize;
            let move = (jumpLen ? jumpLen : 2) / ratio;
            let oldScrollTop = el.scrollTop;
            el.scrollTop = (el.scrollTop + move);
            //console.log('moveDown', `jumpLen: ${jumpLen}, elSize: ${elSize}, scrollSize: ${scrollSize}, ratio: ${ratio}, move: ${move}, oldScrollTop: ${oldScrollTop}, newScrollTop: ${el.scrollTop}`);

            me.scrollTopValue = el.scrollTop;
            if (el.scrollTop != oldScrollTop)
                me.thumbPos = me.thumbPos + jumpLen;
            //me.updateVerticalScroller(false);

        }

        function moveUp(jumpLen: number) {

            if (me.thumbPos != 0 && !me.thumbPos) {
                console.log('moveUp', 'me.thumbPos is null');
                return;
            }
            let elSize = DomSmallUtils.height(scrollerAreaEl);
            let scrollSize = el.scrollHeight;
            let ratio = elSize / scrollSize;
            let move = (jumpLen ? jumpLen : 2) / ratio;
            let oldScrollTop = el.scrollTop;
            el.scrollTop = (el.scrollTop - move);
            //console.log('moveUp', `jumpLen: ${jumpLen}, elSize: ${elSize}, scrollSize: ${scrollSize}, ratio: ${ratio}, move: ${move}, oldScrollTop: ${oldScrollTop}, newScrollTop: ${el.scrollTop}`);

            me.scrollTopValue = el.scrollTop;
            if (el.scrollTop != oldScrollTop)
                me.thumbPos = me.thumbPos - jumpLen;
          //  me.updateVerticalScroller(false);

        }

        function navigatorClick(e: MouseEvent) {
            if (e.target == navigatorStart) moveUp(2);
            if (e.target == navigatorEnd) moveDown(2);
        }

        function navigatorDown(e: MouseEvent) {

            me.r.addClass(document.body, 'unselectable');
            me.navigatorIsDown = true;

            function onEverlastingScroll() {

                if (me.navigatorIsDown) {
                    navigatorClick(e);
                    setTimeout(onEverlastingScroll, 50);
                }
            }

            setTimeout(function () {
                if (me.navigatorIsDown) onEverlastingScroll();
            }, 300);

        }

        function navigatorUp() {
            me.r.removeClass(document.body, 'unselectable');
            me.navigatorIsDown = false;
        }

        navigatorStart.addEventListener('click', navigatorClick);
        navigatorStart.addEventListener('mousedown', navigatorDown);
        navigatorStart.addEventListener('mouseup', navigatorUp);
        navigatorStart.addEventListener('mouseout', navigatorUp);
        navigatorEnd.addEventListener('click', navigatorClick);
        navigatorEnd.addEventListener('mousedown', navigatorDown);
        navigatorEnd.addEventListener('mouseup', navigatorUp);
        navigatorEnd.addEventListener('mouseout', navigatorUp);

        function emptyAreaClick(e: MouseEvent, pos: number) {
            let thumbEl = DomSmallUtils.find(me.scrollerVDiv, 'div.thumb');

            if (!pos || (me.thumbPos + DomSmallUtils.height(thumbEl) < pos)) moveDown(DomSmallUtils.height(thumbEl));
            else if (!pos || me.thumbPos > pos) moveUp(DomSmallUtils.height(thumbEl));
        }


        function emptyAreaDown(e: MouseEvent) {

            me.r.addClass(document.body, 'unselectable');
            me.emptyAreaIsDown = true;

            function onEverlastingScroll() {

                if (me.emptyAreaIsDown) {

                    let pointerTop = e.pageY - DomSmallUtils.offset(<HTMLElement>e.target).top;
                    emptyAreaClick(e, pointerTop);
                    setTimeout(onEverlastingScroll, 500);

                }
            }

            setTimeout(function () {
                if (me.emptyAreaIsDown) onEverlastingScroll();
            }, 300);


        }

        function emptyAreaUp() {

            me.r.removeClass(document.body, 'unselectable');
            me.emptyAreaIsDown = false;

        }

        scrollerAreaEl.addEventListener('click', function (e: MouseEvent) {
            let el = <HTMLElement>e.target;
            if (!DomSmallUtils.hasClass(el, 'thumb')) {
                let pointerTop = e.pageY - DomSmallUtils.offset(el).top;
                emptyAreaClick(e, pointerTop);
            }
        });

        scrollerAreaEl.addEventListener('mousedown', function (e: MouseEvent) {
            let el = <HTMLElement>e.target;
            if (!DomSmallUtils.hasClass(el, 'thumb')) emptyAreaDown(e);
        });

        scrollerAreaEl.addEventListener('mouseup', function (e: MouseEvent) {
            emptyAreaUp();
        });

        // For all desktop browsers
        el.addEventListener(BrowserDetectEventUtil.getMouseWheelEventName(), (e: WheelEventInit) => {

            if (!this.isOverMe) return;

            const delta = e.deltaY || e.detail;
            //console.log('mousewheel', `delta: ${delta}`);

            // For MacOS we use hidden browser scroll, just do emit onScrollDown to parent component
            if (BrowserDetectUtil.isMac()) {
                console.log('mousewheel.Mac');

                if (me.onScrollDown)
                    me.onScrollDown.emit(me.mouseWheelScrollMove);

                return;
            }

            if (!delta) return;

            if (delta < 0) {
                moveUp(me.mouseWheelScrollMove);
            }
            else if (delta > 0) {
                moveDown(me.mouseWheelScrollMove);
            }

        });

        // For mobile devices
        el.addEventListener('touchstart', (e: TouchEvent) => {
            if (e.targetTouches.length === 1) {
                let touch = e.targetTouches[0];
                this.touchStartY = touch.pageY;
            }
        }, false);
        el.addEventListener('touchmove', (e: TouchEvent) => {
            if (e.targetTouches.length === 1) {
                let touch = e.targetTouches[0];

                if (touch.pageY > this.touchStartY) {
                    moveUp(me.mouseWheelScrollMove);
                } else if (touch.pageY < this.touchStartY) {
                    moveDown(me.mouseWheelScrollMove);
                }
            }
        }, false);


    }

    getCeilOuterWidth(el: HTMLElement): number {
        return Math.ceil(DomSmallUtils.outerWidth(el));
    }

    getCeilOuterHeight(el: HTMLElement): number {
        return Math.ceil(DomSmallUtils.outerHeightFull(el));
    }


    updateScroller(forceCalculateScroll: boolean): void {

        let me = this;
        let el = this.getElDom();
        let scrollerEl = me.scrollerHDiv;
        let scrollSize = parseInt(el.scrollWidth + '');
        let viewportSize = this.getCeilOuterWidth(el);
        let thumbDom = scrollerEl.getElementsByTagName("div")[1].getElementsByTagName("div")[0];

        if (scrollSize <= viewportSize) {
            DomSmallUtils.addClass(this.r, scrollerEl, 'disabled');
            return;
        }
        else {
            DomSmallUtils.removeClass(this.r, scrollerEl, 'disabled');
        }

        let left = el.scrollLeft;

        if (left !== me.scrollerLastLeft || forceCalculateScroll) {

            me.scrollerLastLeft = this.scrollLeftValue = left;
            let elSize = viewportSize;
            let scrollAreaElSize = DomSmallUtils.width(DomSmallUtils.find(me.scrollerHDiv, 'div.thumb-area'));

            let maxScrollSize = scrollSize - elSize;

            let ratio = elSize / scrollSize;
            let scrollRelative = left / maxScrollSize;

            let thumbSize = ((ratio > 1) ? 1 : ratio) * scrollAreaElSize;

            DomSmallUtils.setStyle(this.r, thumbDom, 'width', thumbSize + 'px');

            me.thumbPos = parseInt(scrollRelative * (scrollAreaElSize - thumbSize)+"");

            DomSmallUtils.setStyle(this.r, thumbDom, 'left', this.thumbPos + 'px');

        }

    }

    isVerticalScroll(): boolean {

        let me = this;
        let el = this.getElDom();
        let scrollSize = parseInt(el.scrollHeight + '');
        let viewportSize = this.getCeilOuterHeight(el);

        if (scrollSize <= viewportSize) return false;
        else return true;

    }

    isHorizontalScroll(): boolean {

        let me = this;
        let el = this.getElDom();
        let scrollSize = parseInt(el.scrollWidth + '');
        let viewportSize = this.getCeilOuterWidth(el);

        if (scrollSize <= viewportSize) return false;
        else return true;

    }

    updateVerticalScroller(forceCalculateScroll: boolean): void {

        let me = this;
        let el = this.getElDom();
        let scrollerEl = me.scrollerVDiv;
        let scrollSize = parseInt(el.scrollHeight + '');
        let thumbDom = scrollerEl.getElementsByTagName("div")[1].getElementsByTagName("div")[0];

        if (!me.isVerticalScroll()) {
            DomSmallUtils.addClass(this.r, scrollerEl, 'disabled');
            return;
        }
        else
            DomSmallUtils.removeClass(this.r, scrollerEl, 'disabled');


        let top = el.scrollTop;

        if (top !== me.scrollerLastTop || forceCalculateScroll) {

            me.scrollerLastTop = this.scrollTopValue = top;
            let elSize = this.getCeilOuterHeight(el);
            let scrollAreaElSize = DomSmallUtils.height(DomSmallUtils.find(me.scrollerVDiv, 'div.thumb-area'));

            let maxScrollSize = scrollSize - elSize;

            let ratio = elSize / scrollSize;
            let scrollRelative = top / maxScrollSize;

            let thumbSize = ((ratio > 1) ? 1 : ratio) * scrollAreaElSize;

            DomSmallUtils.setStyle(this.r, thumbDom, 'height', thumbSize + 'px');

            me.thumbPos = parseInt(scrollRelative * (scrollAreaElSize - thumbSize)+"");

            DomSmallUtils.setStyle(this.r, thumbDom, 'top', me.thumbPos + 'px');

        }

    }

    getScrollTop(): number {

        let me = this;

        let el = this.getElDom();

        return el.scrollTop;

    }

    setScrollTop(top: number): void {

        let me = this;

        let el = this.getElDom();

        el.scrollTop = top;
        me.scrollTopValue = el.scrollTop;

    }

    scrollToBottom(): void {

        let me = this;

        let el = this.getElDom();

        el.scrollTop = el.scrollHeight;
        me.scrollTopValue = el.scrollTop;

    }

    setScrollTopPosition(top: number): void {
        this.horizontalScrollerTop = top;
        DomSmallUtils.setStyle(this.r, this.scrollerHDiv, 'top', this.horizontalScrollerTop + 'px');
    }

    setScrollLeftPosition(left: number): void {
        this.verticalScrollerLeft = left;
        DomSmallUtils.setStyle(this.r, this.scrollerVDiv, 'left', this.verticalScrollerLeft + 'px');
    }

    updateTopPosition(): void {

        let me = this;

		let isRelative = me.isRelativeContainer();

        let el = this.getElDom();

        let h = this.getCeilOuterHeight(el);

        me.setScrollTopPosition(isRelative ? (h - me.scrollerSize) : (DomSmallUtils.position(el).top + h - me.scrollerSize));

    }

    updateLeftPosition(): void {

        let me = this;

		let isRelative = me.isRelativeContainer();


        let el = this.getElDom();

        if (me.verticalScrollPosition) {

            let pos = DomSmallUtils.position(el);


            if (me.verticalScrollPosition == 'right' || !me.isVerticalScroll()) {

                let w = this.getCeilOuterWidth(el);

                me.verticalScrollerLeft = isRelative ? (w - me.scrollerSize) : (pos.left + w - me.scrollerSize);
                if (me.getContentEl())
                    this.r.setStyle(me.getContentEl(), 'margin-left', 0);

            }
            else {

                me.verticalScrollerLeft = isRelative ? 0 : pos.left;
                if (me.getContentEl()) this.r.setStyle(me.getContentEl(), 'margin-left', me.scrollerSize + 'px');

            }

        }

        me.setScrollLeftPosition(me.verticalScrollerLeft);

    }

	removeDocListeners(): void {

        let me = this;

        if (me.documentListeners) {

            me.documentListeners.forEach(function (lis) {

                document.removeEventListener(lis.key, lis.func);

            });

        }

    }

    onDestroy(): void {

        let me = this;

        let el = this.getElDom();

        if(el) el.removeChild(me.scrollerHDiv);
        if(el) el.removeChild(me.scrollerVDiv);

        me.removeDocListeners();

        if (this.drgEndSubscription) this.drgEndSubscription.unsubscribe();


    }

    public getScrollerSize(): number {

        return this.scrollerSize;

    }

    private overMe(target: EventTarget | null): boolean {

        if (!target) return false;

        const el = (<HTMLElement>target).closest('scrolldiv');
        if (!el) return false;
        if (el === this.getElDom()) return true;
        if (Utils.isScrolledVertically(<HTMLElement>el)) return false;

        return this.overMe(el.parentNode);

    }

    private onMouseMove(ev: MouseEvent): void {

        this.isOverMe = this.overMe(ev.target);
        if (!this.ddService.isDragActive()) return;



        this.dragHandler(ev);

    }

    @HostListener('mouseenter', ['$event'])
    onMouseEnter(ev: MouseEvent): void {

        this.isOverMe = this.overMe(ev.target);
        if (this.moveListener) this.moveListener();
        this.moveListener = this.r.listen(this.getElDom(), 'mousemove', (ev) => { this.onMouseMove.bind(this, ev)(); });

    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(ev: MouseEvent): void {

        this.isOverMe = this.overMe(ev.target);
        if (this.dragInterval) clearInterval(this.dragInterval);
        if (this.moveListener) this.moveListener();

    }

    private onDragEnd(): void {

        if (this.dragInterval) clearInterval(this.dragInterval);

    }

    private dragHandler(ev: MouseEvent) {

        let scrDiv = this.getElDom();

        if (ev.pageY > DomSmallUtils.offset(scrDiv).top + DomSmallUtils.height(scrDiv) - 36) {

            if (this.dragInterval) clearInterval(this.dragInterval);
            this.dragInterval = setInterval(() => { if (ev.pageY > DomSmallUtils.offset(scrDiv).top + DomSmallUtils.height(scrDiv) - 36) scrDiv.scrollTop = scrDiv.scrollTop + 36; else clearInterval(this.dragInterval); }, 500);

        }


        if (ev.pageY < DomSmallUtils.offset(scrDiv).top + 36) {

            if (this.dragInterval) clearInterval(this.dragInterval);
            this.dragInterval = setInterval(() => { if (ev.pageY < DomSmallUtils.offset(scrDiv).top + 36) scrDiv.scrollTop = scrDiv.scrollTop - 36; else clearInterval(this.dragInterval); }, 500);

        }

    }

    public topDragScroll(): void {

        let scrDiv = this.getElDom();
        if (this.dragInterval) clearInterval(this.dragInterval);
        this.dragInterval = setInterval(() => { scrDiv.scrollTop = scrDiv.scrollTop - 36; }, 500);

    }

    public downDragScroll(): void {

        let scrDiv = this.getElDom();
        if (this.dragInterval) clearInterval(this.dragInterval);
        this.dragInterval = setInterval(() => { scrDiv.scrollTop = scrDiv.scrollTop + 36; }, 500);

    }

    public clearDragScroll(): void {

        if (this.dragInterval) clearInterval(this.dragInterval);

    }

    public isDragScrolling(): boolean {
        const VDivDragging = DomSmallUtils.hasClass(DomSmallUtils.find(this.scrollerVDiv, 'div.thumb-area'), 'dragScrolling');
        const HDivDragging = DomSmallUtils.hasClass(DomSmallUtils.find(this.scrollerHDiv, 'div.thumb-area'), 'dragScrolling');
        return VDivDragging || HDivDragging;
    }
}